import step1Image from 'assets/images/facility/how-it-works/select-unit.svg';
import step2Image from 'assets/images/facility/how-it-works/reserve-for-free.svg';
import step3Image from 'assets/images/facility/how-it-works/visit-facility.svg';
import step4Image from 'assets/images/facility/how-it-works/move-in.svg';

import OMIstep2Image from 'assets/images/facility/how-it-works/provide-details.svg';
import OMIstep3Image from 'assets/images/facility/how-it-works/express-checkin.svg';
import OMIstep4Image from 'assets/images/facility/how-it-works/straight-to-unit.svg';

export const steps = [
	{
		image: step1Image,
		stepName: 'Select your unit',
	},
	{
		image: step2Image,
		stepName: 'Reserve for free',
		subtext: 'Cancel or change your reservation at any time, risk-free',
	},
	{
		image: step3Image,
		stepName: 'Visit your facility',
	},
	{
		image: step4Image,
		stepName: 'Move in',
	},
];

export const OMISteps = [
	{
		image: step1Image,
		stepName: 'Select your unit',
	},
	{
		image: OMIstep2Image,
		stepName: 'Provide your details',
		subtext:
			'We just need your name and contact information to reserve your unit',
	},
	{
		image: OMIstep3Image,
		stepName: 'Express check-in',
		subtext:
			'Check into this facility online, eliminating the need to fill out rental paperwork at the facility',
	},
	{
		image: OMIstep4Image,
		stepName: 'Go straight to your unit',
		subtext:
			'All you have to do on your move-in date is move items into your storage unit',
	},
];
